import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const ToggleWrapper = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.n60};
  border-radius: ${({ theme }) => theme.space + 2}px;
`;
